import { RateSchedule } from 'src/app/shared/models/gql/rate.model';

export const DAY_OF_WEEK_DESCRIPTION: Partial<Record<keyof RateSchedule, string>> = {
  weekday: 'Weekday (Mon-Fri)',
  saturday: 'Saturday',
  sunday: 'Sunday',
  publicHoliday: 'Public Holiday',
} as const;

export const TIME_OF_DAY_DESCRIPTION: Partial<Record<keyof RateSchedule, string>> = {
  daytime: 'Daytime (ends between 6am - 8pm)',
  evening: 'Evening (ends between 8pm - Midnight)',
  overnight: 'Overnight active (starts and/or ends between Midnight - 6am)',
} as const;
